import React from 'react';
import type { CSSProperties } from 'react';

import PropTypes from 'prop-types';

import { XSS_FILTER_OPTIONS, XSS_HARSH_FILTER_OPTIONS } from 'apps/auth/constants/Constants';
import { filterXSS } from 'xss';

import { Text } from '../Text/Text';
import type { TextColor, TextSize, TextVariant } from '../Text/Text';

export type DangerouslyHtmlType = 'text' | 'span';

export interface DangerouslyHtmlProps {
    type?: DangerouslyHtmlType;
    dangerouslyHtml?: string;
    variant?: TextVariant;
    size?: TextSize;
    color?: TextColor;
    textAlign?: CSSProperties['textAlign'];
    sanitizeAllHtmlTags?: boolean;
}

export const DangerouslyHtml = ({ sanitizeAllHtmlTags = false, type, dangerouslyHtml, variant, color, size, textAlign }: DangerouslyHtmlProps) => {
    const data = filterXSS(dangerouslyHtml ?? '', sanitizeAllHtmlTags ? XSS_HARSH_FILTER_OPTIONS : XSS_FILTER_OPTIONS);

    if (type === 'text') {
        return <Text variant={variant} color={color} size={size} textAlign={textAlign} dangerouslySetInnerHTML={{ __html: data }} />;
    }
    if (type === 'span') {
        return <span dangerouslySetInnerHTML={{ __html: data }} />;
    }
    return <div dangerouslySetInnerHTML={{ __html: data }} />;
};

DangerouslyHtml.propTypes = {
    type: PropTypes.oneOf(['text', 'span']),
    dangerouslyHtml: PropTypes.string,
    variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'pre', 'paragraph', 'div', 'span', 'link', 'button']),
    size: PropTypes.oneOf(['display2', 'display1', 'header', 'main', 'secondary', 'subheader', 'tag']),
    color: PropTypes.oneOf(['primary', 'secondary', 'lightGray', 'error', 'white', 'white_base', 'whiteRgba40', 'black_base']),
    textAlign: PropTypes.oneOf(['left', 'center', 'right']),
    sanitizeAllHtmlTags: PropTypes.bool,
};
